import React from 'react'
import * as routes from '~/constants/routes'
import AssetLink from '~/components/Scheme/AssetLink'
import { Scheme } from '~/gql/generated/graphql'

interface ModuleLinkProps {
  id: string
  children?: React.ReactNode
}

interface VehicleLinkProps extends ModuleLinkProps {
  bikeScheme?: Pick<Scheme, 'id'>
}

export const VehicleLink = ({ id, bikeScheme, children }: VehicleLinkProps) => (
  <AssetLink
    basePath={`${routes.VEHICLES}/by_module_id`}
    id={id}
    schemeId={bikeScheme?.id}
  >
    {children || id}
  </AssetLink>
)

export const ModuleLink = ({ id, children }: ModuleLinkProps) => (
  <AssetLink basePath={routes.MODULE} id={id}>
    {children || id}
  </AssetLink>
)

export const VehicleModuleLink = ({ id, bikeScheme }) => {
  if (bikeScheme?.id) return <VehicleLink id={id} bikeScheme={bikeScheme} />
  return <ModuleLink id={id} />
}
